module.exports = __webpack_public_path__ + "static/media/2021_2A3A1079.61064eb8.jpg";